import Vue from "vue";

export default {
  async get() {
    const response = await Vue.axios.get("");
    return response.data;
  },
  async getSpot(id) {
    const response = await Vue.axios.get(`spots/${id}`);
    return response.data;
  }
};
